import React, { useState } from 'react';

import { Alert } from 'antd';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { useGroupRows } from '@hooks/API/UseInvoices';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWInput } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const GroupDrawer = (props) => {
    const { onClose, invoiceID, invoiceRowIDs } = props;
    const [touchForm, setTouchForm] = useState(false);
    const { mutateAsync: onGroupRows } = useGroupRows();
    const [errorGrouping, setErrorGrouping] = useState(null);

    const initialValues = {
        text: '',
    };

    const saveGroupRows = async (values, setSubmitting) => {
        setSubmitting(true);
        setErrorGrouping(null);
        try {
            await onGroupRows({
                ID: invoiceID,
                data: {
                    invoiceRowIDs: invoiceRowIDs,
                    text: values.text,
                },
            });
            onClose();
        } catch (e) {
            setErrorGrouping(`Error grouping lines: ${e?.message || 'unknown error'}`);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose} title="Group selected lines">
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    saveGroupRows(values, setSubmitting);
                }}
                validationSchema={Yup.object().shape({
                    text: Yup.string().required('Content is required'),
                })}
                render={({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                        <Field
                            component={NWInput}
                            label="Text"
                            name="text"
                            maxLength={50}
                            type="text"
                            value={values.text}
                        />
                        {errorGrouping && <Alert style={{ margin: '1rem 0' }} message={errorGrouping} type="error" />}
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            />
        </NwDrawer>
    );
};

export default GroupDrawer;
